import { useEffect, lazy, Suspense } from "react";
import { useLocation } from "wouter";
import Hero from "@/components/landing/hero";
import Stats from "@/components/landing/stats";
import Features from "@/components/landing/features";
// import ComparisonChart from "@/components/landing/comparison-chart";
// import ValueProposition from "@/components/landing/value-proposition";
// import WaitlistForm from "@/components/landing/waitlist-form";
import Footer from "@/components/landing/footer";

const WaitlistForm = lazy(() => import("@/components/landing/waitlist-form"));
const ComparisonChart = lazy(() => import("@/components/landing/comparison-chart"));
const ValueProposition = lazy(() => import("@/components/landing/value-proposition"));

export default function Home() {
  const [, params] = useLocation();

  useEffect(() => {
    // Check if we should scroll to waitlist after navigation
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get('scrollToWaitlist') === 'true') {
      // Small delay to ensure the component is mounted
      setTimeout(() => {
        document.getElementById('waitlist')?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }, []);

  return (
    <div className="min-h-screen bg-background font-sans">
      <Hero />
      <Suspense fallback={<div>Loading chart...</div>}>
        <ComparisonChart />
      </Suspense>
      <Stats />
      <Suspense fallback={<div>Loading value proposition...</div>}>
        <ValueProposition />
      </Suspense>
      <Features />
      <div id="waitlist">
        <Suspense fallback={<div>Loading form...</div>}>
          <WaitlistForm />
        </Suspense>
      </div>
      <Footer />
    </div>
  );
}